export default "__VITE_ASSET__a54c8c1a__"